import React from 'react';
import styled from 'styled-components';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import { rhythm } from 'Themes/typography';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Ticket from '../Ticket';
import DeactivateDialog from '../DeactivateDialog';
import axios from 'Axios';

const ProjectNameTypography = styled(Typography)`
  color: white !important;
  font-family: Helvetica, sans-serif !important;
  font-size: ${rhythm(1)} !important;
  line-height: 15px;
`;

const CustomExpansionPanelSummary = styled(ExpansionPanelSummary)`
  min-height: 48px !important;
  // [class*='expanded'] {
  //   margin: 0 !important;
  // }
`;

const Label = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const ProjectDesc = styled.span`
  font-size: 14px;
`;

const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const InfoField = styled.div`
  margin-right: 10px;
  display: flex;
  @media (max-width: 1450px) {
    > span {
      text-indent: -9999px;
    }
  }
`;

const InfoCircle = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 25px;
  min-width: 25px;
  border-radius: 100%;
  background-color: ${props => props.color};
  padding: 5px;
  text-align: center;
  justify-content: center;
  color: ${props => (props.color === '#E0E1E0' ? 'black' : 'white')};
  font-weight: normal;
  margin-right: 5px;
`;

const TicketExpandMoreIcon = styled(ExpandMoreIcon)`
  color: white !important;
`;

const TicketExpansionPanelDetails = styled(ExpansionPanelDetails)`
  padding: 0 5px 5px 5px !important;
`;

class Project extends React.Component {
  state = {
    project: [],
    deleteDialog: false,
    deleteThisTicket: null,
    viewedList: [],
    expanded: false,
  };

  componentDidMount() {
    this.setState({
      project: this.props.project,
      hasNoViewedTickets: this.props.project.hasNotViewedTickets,
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.project.tickets !== this.props.project.tickets) {
      this.setState({ project: this.props.project });
    }
  }

  addToViewedList = (projectId, ticketId) => {
    /**
     * Structure of the viewedList
     * [
     *  {
     *    id: projectId,
     *    children: [
     *      ticketId,
     *      ...
     *    ]
     *  },
     *  ...
     * ]
     */
    //check if the project with projectId is already in the list
    let projectExists = this.state.viewedList.find(ticket => {
      return ticket.id === projectId;
    });
    //if project exists in the list
    if (projectExists) {
      //check if there are already viewed tickets for this project
      if (projectExists.children) {
        //check if the ticket with ticketId exists in the children of the found object
        let ticketExists = projectExists.children.find(child => {
          return child === ticketId;
        });
        //if ticket does not exist add it to the list, we are already sure that ticket is not viewed - see Ticket component navigate function
        if (!ticketExists) {
          for (let i = 0; i < this.state.viewedList.length; i++) {
            if (this.state.viewedList[i].id === projectId) {
              let helpArray = [...this.state.viewedList];
              helpArray[i].children.push(ticketId);
              this.setState({ viewedList: helpArray }, () => {
                if (
                  this.state.viewedList[i].children.length ===
                  this.props.project.notViewedTickets
                ) {
                  this.setState({ hasNoViewedTickets: false });
                }
              });
            }
          }
        }
      } else {
        //if no children but the project id is found - this should never happen, but just in case
        for (let j = 0; j < this.state.viewedList.length; j++) {
          if (this.state.viewedList[j].id === projectExists.id) {
            let addChildrenHelpArr = [...this.state.viewedList];
            addChildrenHelpArr[j].children = [];
            addChildrenHelpArr[j].children.push(ticketId);
            this.setState({ viewedList: addChildrenHelpArr }, () => {
              if (
                this.state.viewedList.find(item => {
                  return item.id === projectId;
                }).children.length === this.props.project.notViewedTickets
              ) {
                this.setState({ hasNoViewedTickets: false });
              }
            });
          }
        }
      }
    } else {
      let viewedHelpArray = [...this.state.viewedList];
      viewedHelpArray.push({ id: projectId, children: [ticketId] });
      this.setState({ viewedList: viewedHelpArray }, () => {
        if (
          this.state.viewedList.find(item => {
            return item.id === projectId;
          }).children.length === this.props.project.notViewedTickets
        ) {
          this.setState({ hasNoViewedTickets: false });
        }
      });
    }
  };

  removeTicketFromSideBar = ticketId => () => {
    this.setState({ deleteDialog: true, deleteThisTicket: ticketId });
  };

  closeDeleteDialog = () => {
    this.setState({ deleteDialog: false });
  };

  doRemove = () => {
    axios
      .put(`/supply/ticket/${this.state.deleteThisTicket}/hide`)
      .then(response => {
        if (response) {
          let tickets = this.state.project.tickets.filter(
            ticket => ticket.ticketId !== this.state.deleteThisTicket
          );
          this.setState(prevState => ({
            project: {
              ...prevState.project,
              tickets,
            },
            deleteThisTicket: null,
          }));
          this.closeDeleteDialog();
        }
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.setState({
          SnackbarMsg: errorMessage,
        });
      });
  };

  updateHasNoViewedTickets = () => {
    this.setState({ hasNoViewedTickets: false });
  };

  onUpdateSlipState = slipId => {
    let hasAnyUpdatedSlipColumnOne = false;
    let hasAnyUpdatedSlipColumnTwo = false;
    let hasAnyUpdatedSlipColumnThree = false;
    let tickets = this.state.project.tickets.map(ticket => {
      ticket.notifications.hasAnyUpdatedSlipColumnOne = false;
      ticket.notifications.hasAnyUpdatedSlipColumnTwo = false;
      ticket.notifications.hasAnyUpdatedSlipColumnThree = false;
      ticket.slips &&
        ticket.slips.map(slip => {
          if (slip.slipId === slipId) {
            slip.updatedBySupplier = false;
          }
          if (slip.slipLevel === 1) {
            if (!ticket.notifications.hasAnyUpdatedSlipColumnOne) {
              ticket.notifications.hasAnyUpdatedSlipColumnOne =
                slip.updatedBySupplier;
            }
            if (!hasAnyUpdatedSlipColumnOne) {
              hasAnyUpdatedSlipColumnOne = slip.updatedBySupplier;
            }
          }
          if (slip.slipLevel === 2) {
            if (!ticket.notifications.hasAnyUpdatedSlipColumnTwo) {
              ticket.notifications.hasAnyUpdatedSlipColumnTwo =
                slip.updatedBySupplier;
            }
            if (!hasAnyUpdatedSlipColumnTwo) {
              hasAnyUpdatedSlipColumnTwo = slip.updatedBySupplier;
            }
          }
          if (slip.slipLevel === 3) {
            if (!ticket.notifications.hasAnyUpdatedSlipColumnThree) {
              ticket.notifications.hasAnyUpdatedSlipColumnThree =
                slip.updatedBySupplier;
            }
            if (!hasAnyUpdatedSlipColumnThree) {
              hasAnyUpdatedSlipColumnThree = slip.updatedBySupplier;
            }
          }
          return slip;
        });
      return ticket;
    });

    this.setState(prevState => ({
      project: {
        ...prevState.project,
        projectNotifications: {
          ...prevState.project.projectNotifications,
          hasAnyUpdatedSlipColumnOne,
          hasAnyUpdatedSlipColumnTwo,
          hasAnyUpdatedSlipColumnThree,
        },
        tickets,
      },
    }));
  };

  render() {
    const { project } = this.state;
    if (project.length === 0) return null;
    return (
      <React.Fragment>
        <ExpansionPanel
          key={project.projectName}
          style={{
            width: '100%',
            backgroundColor: '#37474f',
            margin: 0,
          }}
          onChange={() => this.setState({ expanded: !this.state.expanded })}
        >
          <CustomExpansionPanelSummary expandIcon={<TicketExpandMoreIcon />}>
            <Label>
              <ProjectNameTypography>
                {project.projectName}
                <br />
                <ProjectDesc>{project.projectDesc}</ProjectDesc>
              </ProjectNameTypography>

              <InfoWrapper>
                <InfoField>
                  <Tooltip title="Number of queries">
                    <InfoCircle
                      color={
                        project.ticketNumber && !this.state.hasNoViewedTickets
                          ? '#E0E1E0'
                          : '#b38e22'
                      }
                    >
                      {project.ticketNumber}
                    </InfoCircle>
                  </Tooltip>
                </InfoField>
                <InfoField>
                  <Tooltip title="Luminaires">
                    <InfoCircle
                      color={
                        project.projectNotifications.hasAnyUpdatedSlipColumnOne
                          ? '#f44336'
                          : '#E0E1E0'
                      }
                    >
                      {project.projectNotifications.numberOfNewAndViewedSlips}
                    </InfoCircle>
                  </Tooltip>
                </InfoField>
                <InfoField>
                  <Tooltip title="Matches">
                    <InfoCircle
                      color={
                        project.projectNotifications.hasAnyUpdatedSlipColumnTwo
                          ? '#ffca28'
                          : '#E0E1E0'
                      }
                    >
                      {project.projectNotifications.numberOfMatchedSlips}
                    </InfoCircle>
                  </Tooltip>
                </InfoField>
                <InfoField>
                  <Tooltip title="Selections">
                    <InfoCircle
                      color={
                        project.projectNotifications
                          .hasAnyUpdatedSlipColumnThree
                          ? '#4caf50'
                          : '#E0E1E0'
                      }
                    >
                      {project.projectNotifications.numberOfDealedSlips}
                    </InfoCircle>
                  </Tooltip>
                </InfoField>
              </InfoWrapper>
            </Label>
          </CustomExpansionPanelSummary>
          <TicketExpansionPanelDetails>
            {this.state.expanded ? (
              <div style={{ width: '100%' }}>
                {project.tickets &&
                  project.tickets.map(ticket => {
                    // ovo bi trebalo da je deo gde treba da se renderuje archive button za supply usera
                    return (
                      <Ticket
                        key={ticket.ticketId}
                        ticket={ticket}
                        onUpdateSlipState={this.onUpdateSlipState}
                        removeTicketFromSideBar={this.removeTicketFromSideBar}
                        updateHasNoViewedTickets={this.updateHasNoViewedTickets}
                        projectId={this.props.id}
                        ticketViewed={ticket.hasViewedTicket}
                        numberOfNotViewedTickets={project.notViewedTickets}
                        addToViewedList={this.addToViewedList}
                        viewedList={this.state.viewedList}
                      />
                    );
                  })}
              </div>
            ) : null}
          </TicketExpansionPanelDetails>
        </ExpansionPanel>

        <DeactivateDialog
          element={'Search'}
          doDelete={this.doRemove}
          handleClose={this.closeDeleteDialog}
          isOpen={this.state.deleteDialog}
        />
      </React.Fragment>
    );
  }
}

export default Project;
